import React, { useContext, useMemo } from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from 'components/common/Button'
import Loader from 'components/common/Loader'
import MainLayoutContext from 'contexts/MainLayoutContext'
import useInfiniteFetchRequests from 'hooks/query/useInfiniteFetchRequests'
import c from './EnhancementHistory.module.scss'

function EnhancementHistory() {
  const { t } = useTranslation()

  const { deviceId, user } = useContext(MainLayoutContext)

  const { data, isLoading, isFetchingNextPage, fetchNextPage, hasNextPage } =
    useInfiniteFetchRequests({
      deviceId,
      sourceType: 'image',
      user,
    })

  const historyItems = useMemo(() => {
    if (data === undefined) return []
    return data.pages.flatMap((p) => p)
  }, [data])

  return (
    <div className={c.history}>
      {isLoading ? (
        <div className={c.loader}>
          <Loader />
        </div>
      ) : (
        <>
          <div className={c.grid}>
            {historyItems.map((h) => (
              <div key={h.request.id} className={c.wrapper}>
                <img className={c.image} src={h.assets[0].source_url} alt="" />
                <NavLink className={c.link} to={`/history/${h.request.id}`} />
              </div>
            ))}
          </div>
          {hasNextPage && (
            <Button
              className={c.loadMoreButton}
              onClick={() => fetchNextPage()}
              disabled={isFetchingNextPage}
            >
              {t('general.buttons.loadMore')}
            </Button>
          )}
          <div className={c.filler} />
        </>
      )}
    </div>
  )
}

export default EnhancementHistory
